export enum SlVariant {
  PRIMARY = 'primary',
  SUCCESS = 'success',
  NEUTRAL = 'neutral',
  WARNING = 'warning',
  DANGER = 'danger'
}

export enum SlTooltipPlacement {
  LEFT_START = 'left-start',
  LEFT = 'left',
  LEFT_END = 'left-end',

  RIGHT_START = 'right-start',
  RIGHT = 'right',
  RIGHT_END = 'right-end',

  TOP_START = 'top-start',
  TOP = 'top',
  TOP_END = 'top-end',

  BOTTOM_START = 'bottom-start',
  BOTTOM = 'bottom',
  BOTTOM_END = 'bottom-end'
}

export enum SlFontSize {
  XXS = '--sl-font-size-2x-small', // 0.625rem
  XS = '--sl-font-size-x-small', // 0.75rem
  SM = '--sl-font-size-small', // 0.875rem
  MD = '--sl-font-size-medium', // 1rem
  LG = '--sl-font-size-large', // 1.25rem
  XL = '--sl-font-size-x-large', // 1.5rem
  XXL = '--sl-font-size-2x-large', // 2.25rem
  XXXL = '--sl-font-size-3x-large', // 3rem
  XXXXL = '--sl-font-size-4x-large' // 4.5rem
}
